export const GET_HELP_SUGGESTIONS = 'GET_HELP_SUGGESTIONS'
export const GET_HELP_SUGGESTIONS_TASK_ARE_ASSIGNED_TO = 'GET_HELP_SUGGESTIONS_TASK_ARE_ASSIGNED_TO'
export const GET_ALL_HELP_SUGGESTIONS = 'GET_ALL_HELP_SUGGESTIONS'
export const UPDATE_HELP_SUGGESTIONS = 'UPDATE_HELP_SUGGESTIONS'
export const DELETE_HELP_SUGGESTIONS = 'DELETE_HELP_SUGGESTIONS'
export const CREATE_HELP_SUGGESTIONS = 'CREATE_HELP_SUGGESTIONS'
export const RESET_HELP_SUGGESTIONS = 'RESET_HELP_SUGGESTIONS'
